import { Dispatch, FunctionComponent, SetStateAction, useEffect, useState } from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"
import { Guid } from "../../../api/baseApi";
import { updateUserNotifications, AlertType, getUserNotifications } from "../../../api/usersApi";
import { Button } from "../../components/Button";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import InnerLayout from "../innerLayout/InnerLayout";
import "./UserSettings.css"

interface UserSettingsNotificationProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type NotificationGroups = "Group1" | "Group2" | "Group3" | "Group4" | undefined;
 
const UserSettingsNotification: FunctionComponent<UserSettingsNotificationProps> = (props : UserSettingsNotificationProps) => {
    let {userId} = useParams<{userId:Guid}>();
    let [isLoading, setIsloading] = useState(false);
    let [notifications, setNotifications] = useState<AlertType[]>([]);
    let [isSaveDisabled, setIsSaveDisabled] = useState(true);

    let [isCheckedGroup1, setIsCheckedGroup1] = useState(false);
    let [isCheckedGroup2, setIsCheckedGroup2] = useState(false);
    let [isCheckedGroup3, setIsCheckedGroup3] = useState(false);
    let [isCheckedGroup4, setIsCheckedGroup4] = useState(false);

    let notificationGroup1 = [
        AlertType.NewPlayerRegistered,
        AlertType.PlayerOfflineContinuouslyRorMoreThan5mins,
        AlertType.PlayerOnline,
        AlertType.PlayerUpdatedToNewVersion,
        AlertType.PlayerCrash,
        AlertType.PlayerFreezeForMoreThan30Seconds,
        AlertType.PlayerRestartedByCplayerGuardian,
        AlertType.PlayerCPUUtilizationAbove75PercentContinuouslyAfter3Mins,
        AlertType.PlayerGPUUtilizationAbove60PercentContinuouslyAfter3Mins,
        AlertType.PlayerDiskUtilizationAbove75PercentContinuouslyAfter3Mins,
        AlertType.PlayerNotResponding,
        AlertType.PlayerRestartedByRequest,
        AlertType.PlayerRestartedByFreeze,
        AlertType.Dolby,
        AlertType.RainbowScreen
    ];

    let notificationGroup2 = [
        AlertType.NewUserAdded,
        AlertType.UserDisabled,
        AlertType.UserEnabled,
    ];

    let notificationGroup3 = [
        AlertType.NewCampaignCreated,
        AlertType.CampaignStartedByTheStartDate,
        AlertType.CampaignPlayedByThePlayButton,
        AlertType.CampaignFinishedByTheEndDate,
        AlertType.CampaignStoppedByTheStopButton,
        AlertType.CampaignAchievedByTheArchiveButton,
        AlertType.CampaignStillInDraftMode24hoursAdvancedAlertPriorToStartDate,
        AlertType.CampaignHasNoMediaAssets48HoursAdvancedAlertPriorToStartDate
    ];

    let notificationGroup4 = [
        AlertType.NewSiteCreated,
        AlertType.NewPlayerAddedToTheSite,
        AlertType.NewPlayerRemovedFromTheSite,
        AlertType.NewPlaylistAddedUnderASite,
        AlertType.PlaylistDeletedUnderASite
    ]

    useEffect(()=>{
        async function getData(){
            setIsloading(true);
            await Promise.all([fetchUserNotifications()]);
            setIsloading(false);
        }
        getData();
    },[])

    useEffect(()=>{
        checkIsAllGroupElementsActive(notifications)
    },[notifications])

    async function fetchUserNotifications(){
        setIsloading(true);
        let response = await getUserNotifications(userId)
        if(response.type == "succes") {
            setNotifications(response.data.items);
            checkIsAllGroupElementsActive(response.data.items)
        }
        setIsloading(false);
    }

    const saveNotifications = async () => {
        setIsloading(true);
        let request = {
            notificationTypes: notifications
        }
        await updateUserNotifications(userId, request);
        await fetchUserNotifications();
        setIsSaveDisabled(true);
        setIsloading(false);
    }

    const checkNotificationGroup = (notification: AlertType) : NotificationGroups => {
        if(notificationGroup1.some(it => it === notification)) {return "Group1"}
        if(notificationGroup2.some(it => it === notification)) {return "Group2"}
        if(notificationGroup3.some(it => it === notification)) {return "Group3"}
        if(notificationGroup4.some(it => it === notification)) {return "Group4"}
    }

    const checkIsAllGroupElementsActive = (notifications: AlertType[]) => {
        if(notificationGroup1.every(it => notifications.includes(it))) setIsCheckedGroup1(true);
        if(notificationGroup2.every(it => notifications.includes(it))) setIsCheckedGroup2(true);
        if(notificationGroup3.every(it => notifications.includes(it))) setIsCheckedGroup3(true);
        if(notificationGroup4.every(it => notifications.includes(it))) setIsCheckedGroup4(true);
    }
 
    const updateNotice = ( notification: AlertType) =>{
        if(notifications.findIndex(it => it == notification) !== -1){
            setNotifications(notifications.filter(it => it !== notification));
        }
        else{
            setNotifications([...notifications, notification]);
        }
        switch (checkNotificationGroup(notification)) {
            case "Group1" : setIsCheckedGroup1(false); break;
            case "Group2" : setIsCheckedGroup2(false); break;
            case "Group3" : setIsCheckedGroup3(false); break;
            case "Group4" : setIsCheckedGroup4(false); break;
        }
        setIsSaveDisabled(false);
    } 

    const updateNoticeGroup = (groupNotifications: AlertType[], isCheck: boolean, isCheckCB: Dispatch<SetStateAction<boolean>>) => {
        if(!isCheck){
            setNotifications([...notifications, ...groupNotifications]);
        }
        else {
            setNotifications(notifications.filter(it => !groupNotifications.some( it2 => it2 === it)))
        }
        isCheckCB(prev => !prev);
        setIsSaveDisabled(false);
    }

    const renderNotice = (name: string, notification: AlertType) => {
        return <div className="notification">
            <div className="status-container">
                <span>{name}</span>
                <FormCheckbox
                    checked={notifications.findIndex(it => it == notification) !== -1}
                    id={`notification_${name}`}
                    onChange={()=> updateNotice(notification)}
                />
            </div>
        </div>
    }

    return (  
    <InnerLayout 
        isCollapsed={props.isCollapsed}
        logOut={props.logOut}
        toogleCollapse={props.toogleCollapse}
        activeTab="users">
            <>
                <div className="d-flex justify-content-between align-items-center mb-20 pt-50">
                    <h1>Notifications</h1>
                    <Button color="green" label="Save Changes" isDisabled={isSaveDisabled} onClick={saveNotifications} />
                </div>

                <div className="notification-title-block">
                    <h2>System </h2>

                    <div className="status-container">
                        <span>&nbsp;</span>
                        <FormCheckbox
                            checked={isCheckedGroup1}
                            id={`check_1`}
                            onChange={() => {updateNoticeGroup( notificationGroup1, isCheckedGroup1, setIsCheckedGroup1)}}
                        />
                    </div>
                </div>

                <div className="notifications-block">
                    {renderNotice("New Player registered", AlertType.NewPlayerRegistered)}
                    {renderNotice("Player offline continuously for more than 5 mins", AlertType.PlayerOfflineContinuouslyRorMoreThan5mins)}
                    {renderNotice("Player online", AlertType.PlayerOnline)}
                    {renderNotice("Player updated to new version with new version number", AlertType.PlayerUpdatedToNewVersion)}
                    {renderNotice("Player crash", AlertType.PlayerCrash)}
                    {renderNotice("Player freeze for more than 30 seconds", AlertType.PlayerFreezeForMoreThan30Seconds)}
                    {renderNotice("Player not responding", AlertType.PlayerNotResponding)}
                    {renderNotice("Player restarted by CplayerGuardian", AlertType.PlayerRestartedByCplayerGuardian)}
                    {renderNotice("Player CPU utilisation above 75% continuously after 3 mins", AlertType.PlayerCPUUtilizationAbove75PercentContinuouslyAfter3Mins)}
                    {renderNotice("Player GPU utilisation above 60% continuously after 3 mins", AlertType.PlayerGPUUtilizationAbove60PercentContinuouslyAfter3Mins)}
                    {renderNotice("Player disk utilisation above 75% continuously after 3 mins", AlertType.PlayerDiskUtilizationAbove75PercentContinuouslyAfter3Mins)}
                    {renderNotice("Player restarted by request", AlertType.PlayerRestartedByRequest)}
                    {renderNotice("Player restarted by freeze", AlertType.PlayerRestartedByFreeze)}
                    {renderNotice("Dolby", AlertType.Dolby)}
                    {renderNotice("Stream Feed Unavailable", AlertType.RainbowScreen)}
                </div>

                <div className="notification-title-block">
                    <h2>User </h2>
                    <div className="status-container">
                        <span>&nbsp;</span>
                        <FormCheckbox
                            checked={isCheckedGroup2}
                            id={`check_2`}
                            onChange={() => {updateNoticeGroup( notificationGroup2, isCheckedGroup2, setIsCheckedGroup2)}}
                        />
                    </div>
                </div>

                <div className="notifications-block">
                    {renderNotice("New user added", AlertType.NewUserAdded)}
                    {renderNotice("User disabled", AlertType.UserDisabled)}   
                    {renderNotice("User enabled", AlertType.UserEnabled)}
                </div>

                <div className="notification-title-block">
                    <h2>Campaign </h2>
                    <div className="status-container">
                        <span>&nbsp;</span>
                        <FormCheckbox
                            checked={isCheckedGroup3}
                            id={`check_3`}
                            onChange={() => {updateNoticeGroup( notificationGroup3, isCheckedGroup3, setIsCheckedGroup3)}}
                        />
                    </div>
                </div>

                <div className="notifications-block">
                    {renderNotice("New campaign created", AlertType.NewCampaignCreated)}
                    {renderNotice("Campaign started by the start date (email sent from 9am until 5:30pm)", AlertType.CampaignStartedByTheStartDate)}
                    {renderNotice("Campaign played by the play button", AlertType.CampaignPlayedByThePlayButton)}
                    {renderNotice("Campaign finished by the end date (email sent from 9am until 5:30pm)", AlertType.CampaignFinishedByTheEndDate)}
                    {renderNotice("Campaign stopped by the stop button", AlertType.CampaignStoppedByTheStopButton)}
                    {renderNotice("Campaign achieved by the archive button", AlertType.CampaignAchievedByTheArchiveButton)}
                    {renderNotice("Campaign still in draft mode 24 hours advanced alert prior to start date", AlertType.CampaignStillInDraftMode24hoursAdvancedAlertPriorToStartDate)}
                    {renderNotice("Campaign has no media assets 48 hours advanced alert prior to start date", AlertType.CampaignHasNoMediaAssets48HoursAdvancedAlertPriorToStartDate)}
                </div>

                <div className="notification-title-block">
                    <h2>Network </h2>
                    <div className="status-container">
                        <span>&nbsp;</span>
                        <FormCheckbox
                            checked={isCheckedGroup4}
                            id={`check_4`}
                            onChange={() => {updateNoticeGroup( notificationGroup4, isCheckedGroup4, setIsCheckedGroup4)}}
                        />
                    </div>
                </div>

                <div className="notifications-block">
                    {renderNotice("New network created with the name", AlertType.NewSiteCreated)}
                    {renderNotice("New player added to the network with player name and network name", AlertType.NewPlayerAddedToTheSite)}
                    {renderNotice("New player removed from the network with player name and network name", AlertType.NewPlayerRemovedFromTheSite)}
                    {renderNotice("New playlist added under a network with the new playlist name and network name", AlertType.NewPlaylistAddedUnderASite)}
                    {renderNotice("Playlist deleted under a network with the playlist name and network name", AlertType.PlaylistDeletedUnderASite)}
                </div>

                <GlobalSpinner isShow={isLoading} />
            </>
           
    </InnerLayout> );
}
 
export default withRouter(UserSettingsNotification);